import React from 'react';

function Sound() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M0 8v8h5.333L12 22.667V1.333L5.333 8H0zm18 4c0-2.36-1.36-4.387-3.333-5.373V17.36C16.64 16.387 18 14.36 18 12zM14.667.307v2.746C18.52 4.2 21.333 7.773 21.333 12c0 4.227-2.813 7.8-6.666 8.947v2.746C20.013 22.48 24 17.707 24 12S20.013 1.52 14.667.307z" />
    </svg>
  );
  /* eslint-enable */
}

export default Sound;



// WEBPACK FOOTER //
// ./src/common/icons/Sound.js